import { render, staticRenderFns } from "./Item_Entrega.vue?vue&type=template&id=16e4d2a0"
import script from "./Item_Entrega.vue?vue&type=script&lang=js"
export * from "./Item_Entrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports